/* eslint-disable */
import React from "react";
import { decode as base64_decode } from 'base-64';

const Description = ({career, language}) => {
    return (
    <>
        <div className="content">
            <div className="col-our-office-location">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                        <h1>
                            {career?.position_name}
                        </h1>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                        <b>
                            {language === "EN" ? "Job Description : " : "Deskripsi Pekerjaan : "}
                        </b>
                        </div>
                    </div>
                    <div className=" mt-3">
                        <div className="col-md-12">
                        {language === "EN" && career?.en_desc && (
                            <div
                            style={{ marginTop: "10px", marginBottom: "80px" }}
                            dangerouslySetInnerHTML={{
                                __html: decodeURIComponent(
                                escape(base64_decode(career.en_desc))
                                ),
                            }}
                            ></div>
                        )}

                        {language === "ID" && career?.id_desc && (
                            <div
                            style={{ marginTop: "10px", marginBottom: "80px" }}
                            dangerouslySetInnerHTML={{
                                __html: decodeURIComponent(
                                escape(base64_decode(career.id_desc))
                                ),
                            }}
                            ></div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default Description;